<div class="screen">
  <mat-spinner [diameter]="25"></mat-spinner>
  <ng-container *ngIf="hasTitle">
    <div class="title">{{"please_wait"|translate}}</div>
  </ng-container>
</div>
